import React from 'react';
import { GridColumnMenuContainer } from '@mui/x-data-grid-premium';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { DeleteOutlineRounded, EditRounded, FileCopyRounded, FlashOnRounded } from '@mui/icons-material';
import { AddLink, LinkOff, PanoramaRounded, FunctionsRounded } from '@mui/icons-material';
import { red } from '@mui/material/colors';

const OPTION_TYPES = ['dropbox', 'tickbox', 'status', 'weightedList'];

export default function DataGridColumnMenu(props) {
  const { colDef } = props;
  const { columnsEditable, onMenuItemClicked, fieldType, refLimitReached, isReference } = colDef;

  const showEditOptions =
    columnsEditable &&
    [
      'dropbox',
      'weightedList',
      'tickbox',
      'status',
      'dataSet',
      'stock',
      'calculation',
      'action',
      'actionGroup',
      'readAndSign',
      'colorCheck',
      'number',
    ].includes(fieldType);

  const showAutomations = columnsEditable && OPTION_TYPES.includes(fieldType);

  const isStatus = fieldType === 'status';
  const showRef = !refLimitReached || isReference;
  const showDisplaySettings = fieldType === 'image';
  const showSummarySettings = fieldType === 'number' || fieldType === 'calculation';

  return (
    <GridColumnMenuContainer
      {...props}
      slots={{
        columnMenuColumnsItem: null,
      }}
    >
      {props.defaultItems}

      {showEditOptions && (
        <MenuItem onClick={() => onMenuItemClicked('editOptions')}>
          <ListItemIcon>
            <EditRounded />
          </ListItemIcon>
          <ListItemText>Edit options</ListItemText>
        </MenuItem>
      )}

      {columnsEditable && (
        <MenuItem onClick={() => onMenuItemClicked('duplicateColumn')}>
          <ListItemIcon>
            <FileCopyRounded />
          </ListItemIcon>
          <ListItemText>Duplicate column</ListItemText>
        </MenuItem>
      )}

      {showRef &&
        (isReference ? (
          <MenuItem onClick={() => onMenuItemClicked('removeReference')}>
            <ListItemIcon>
              <LinkOff />
            </ListItemIcon>
            <ListItemText>Remove reference</ListItemText>
          </MenuItem>
        ) : (
          <MenuItem onClick={() => onMenuItemClicked('addReference')}>
            <ListItemIcon>
              <AddLink />
            </ListItemIcon>
            <ListItemText>Use as reference</ListItemText>
          </MenuItem>
        ))}

      {columnsEditable && isStatus && (
        <MenuItem onClick={() => onMenuItemClicked('actions')}>
          <ListItemIcon>
            <FlashOnRounded />
          </ListItemIcon>
          <ListItemText>Actions</ListItemText>
        </MenuItem>
      )}

      {showAutomations && (
        <MenuItem onClick={() => onMenuItemClicked('automations')}>
          <ListItemIcon>
            <FlashOnRounded />
          </ListItemIcon>
          <ListItemText>Automations</ListItemText>
        </MenuItem>
      )}

      {showDisplaySettings && (
        <MenuItem onClick={() => onMenuItemClicked('displaySettings')}>
          <ListItemIcon>
            <PanoramaRounded />
          </ListItemIcon>
          <ListItemText>Display settings</ListItemText>
        </MenuItem>
      )}

      {columnsEditable && (
        <MenuItem onClick={() => onMenuItemClicked('deleteColumn')}>
          <ListItemIcon>
            <DeleteOutlineRounded sx={{ color: red[500] }} />
          </ListItemIcon>
          <ListItemText sx={{ color: red[500] }}>Delete column</ListItemText>
        </MenuItem>
      )}
    </GridColumnMenuContainer>
  );
}
